import { config, type AdminEnvelope, type TokenSet } from "./types";

export class AdminApiError extends Error {
  constructor(public readonly status: number, public readonly code: string, message: string) { super(message); }
}

export async function adminRequest<T>(path: string, tokens: TokenSet | null, init?: RequestInit): Promise<AdminEnvelope<T>> {
  const headers = new Headers(init?.headers);
  headers.set("accept", "application/json");
  if (init?.body) headers.set("content-type", "application/json");
  if (config.authMode === "dev") headers.set("authorization", "Bearer local-development-only");
  else if (tokens) headers.set("authorization", `Bearer ${tokens.accessToken}`);
  let response: Response;
  try { response = await fetch(`${config.apiBaseUrl.replace(/\/$/, "")}${path}`, { ...init, headers }); }
  catch { throw new AdminApiError(0, "admin_network_unavailable", "The console could not reach its API. Check your connection, then try again."); }
  const payload = await response.json().catch(() => null) as AdminEnvelope<T> | null;
  if (!response.ok) {
    const error = payload?.data as { error?: { code?: string; message?: string } } | undefined;
    throw new AdminApiError(response.status, error?.error?.code ?? "admin_request_failed", error?.error?.message ?? `Request failed (${response.status}).`);
  }
  if (!payload) throw new AdminApiError(502, "admin_response_invalid", "The admin API returned an unreadable response.");
  return payload;
}

export function mutationBody(input: { reason: string; confirmation: string; [key: string]: unknown }): { body: string; headers: Record<string, string> } {
  const idempotencyKey = crypto.randomUUID();
  return { body: JSON.stringify({ ...input, idempotencyKey }), headers: { "x-idempotency-key": idempotencyKey } };
}
